export default "__VITE_ASSET__YcdheVnr__"